import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import classNames from "classnames";
import { __ } from "@jti/fe-common";
import { InputFooter, InputLabel } from "../../partials/form-blocks/FormBlocks";
import ArrowDown from "../../utils/icons/chevron-down.svg";
import { FormElement } from "../form-element/FormElement";
import "./Select.scss";
const Select = ({ label, id, placeholder, disclaimer, reasons, requiredMessage, validationRules, formConfig, items, onChangeCascadingSelect, }) => {
    const options = reasons || items;
    const hasReasons = reasons?.length;
    const hasErrors = Boolean(formConfig?.errors[id]);
    const defaultReason = options && hasReasons && !placeholder ? options[0]?.items : null;
    const [activeReason, setActiveReason] = useState(defaultReason);
    const toggleReason = (event, id) => {
        if (onChangeCascadingSelect) {
            onChangeCascadingSelect(id);
        }
        if (hasReasons) {
            const selectedReason = Number(event.target.selectedIndex);
            if (options) {
                if (formConfig?.unregister && activeReason) {
                    formConfig.unregister(activeReason.map(({ id }) => id));
                }
                setActiveReason(options[selectedReason]?.items);
            }
        }
    };
    const labelId = id ? `label-${id.replace(/\s+/g, "-")}` : undefined;
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: classNames("aem-dropdown", {
                    "aem-dropdown--invalid": hasErrors,
                }), id: id, children: [_jsx(InputLabel, { label: label, htmlFor: id, id: labelId, required: validationRules?.required }), _jsx("span", { className: "aem-dropdown__arrow", children: _jsx("span", { className: "icon__wrapper", children: _jsx(ArrowDown, {}) }) }), _jsxs("select", { ...formConfig?.register(id, { ...validationRules, onChange: (e) => toggleReason(e, id) }), "aria-labelledby": labelId, name: id, defaultValue: placeholder, "data-testid": `select-dropdown-${id}`, className: "aem-dropdown__select", disabled: !options?.length, children: [placeholder && (_jsx("option", { value: "", style: { display: "none" }, selected: true, children: placeholder })), options?.map(({ subject, translatedName }, index) => (_jsx("option", { "data-testid": `option-${index}`, value: subject, children: translatedName || subject }, index)))] }), _jsx(InputFooter, { displayError: hasErrors, disclaimer: disclaimer, message: requiredMessage || __("contact.form.requiredmessage") })] }), _jsx("div", { children: hasReasons && (_jsx("div", { className: "fields-container", children: activeReason?.map((item) => {
                        if (!item?.resourceName) {
                            return null;
                        }
                        return (_jsx("div", { className: "aem-input-wrapper", children: _jsx(FormElement, { item: item, formConfig: formConfig }) }, item.id));
                    }) })) })] }));
};
export default Select;
//# sourceMappingURL=Select.js.map